import { render } from "./CloseBtn.vue?vue&type=template&id=09e87e57&ts=true"
import script from "./CloseBtn.vue?vue&type=script&lang=ts"
export * from "./CloseBtn.vue?vue&type=script&lang=ts"

import "./CloseBtn.vue?vue&type=style&index=0&id=09e87e57&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__